import React from "react";
import CustomPromoErrorModal from "components/CustomPromo/CustomPromoErrorModal/CustomPromoErrorModal";
import { LanguageCode } from "src/utils/localization/languages/types";
import {
  BlockContentValue,
  PartialSanityImageType
} from "@silversea-ssc/ui-components-react";

const CustomPromoModal = React.lazy(() => import("./CustomPromoModal"));

type Props = {
  title: string;
  isVisible: boolean;
  isPromoValid: boolean;
  onRequestClose: () => void;
  languageCode: LanguageCode;
  backgroundImage: PartialSanityImageType | undefined;
  promoExpirationDate: Date | undefined;
  modalTitle: BlockContentValue;
  modalContent: BlockContentValue;
  promoConfigurationCode: string | undefined;
};

const MaybeCustomPromoModal: React.FC<Props> = ({
  title,
  isVisible,
  isPromoValid,
  onRequestClose,
  languageCode,
  backgroundImage,
  promoExpirationDate,
  modalTitle,
  modalContent,
  promoConfigurationCode
}) => {
  return (
    <React.Suspense>
      {!isPromoValid ? (
        <CustomPromoErrorModal
          isOpen={isVisible}
          onRequestClose={onRequestClose}
          languageCode={languageCode}
        />
      ) : (
        <CustomPromoModal
          isOpen={isVisible}
          onRequestClose={onRequestClose}
          title={title}
          backgroundImage={backgroundImage}
          promoExpirationDate={promoExpirationDate}
          modalTitle={modalTitle}
          modalContent={modalContent}
          promoConfigurationCode={promoConfigurationCode}
        />
      )}
    </React.Suspense>
  );
};

export default MaybeCustomPromoModal;
